import { Link } from 'react-router-dom';
import { liveMatches, sportCategories } from '@/mocks/sportsData';

export default function LiveMatches() {
  const liveAndUpcoming = liveMatches.filter((m) => m.status !== 'finished').slice(0, 4);

  const getCategoryIcon = (catSlug: string) => {
    const cat = sportCategories.find((c) => c.slug === catSlug);
    return cat ? cat.icon : 'ri-trophy-line';
  };

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-2">
              实时赛事直播
            </h2>
            <p className="text-sm text-foreground-600">正在进行的精彩比赛，不错过每一个瞬间</p>
          </div>
          <Link
            to="/category/football"
            className="hidden sm:flex items-center gap-1 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors duration-200"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {liveAndUpcoming.map((match) => (
            <div
              key={match.id}
              className="bg-background-100 rounded-lg p-5 border border-background-200/70 hover:border-primary-200 transition-all duration-300 cursor-pointer group"
            >
              <div className="flex items-center justify-between mb-3">
                <span className="text-xs text-foreground-500 flex items-center gap-1">
                  <i className={`${getCategoryIcon(match.category)}`}></i>
                  {match.league}
                </span>
                {match.status === 'live' && (
                  <span className="flex items-center gap-1 text-xs text-primary-500 font-semibold">
                    <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
                    直播中
                  </span>
                )}
                {match.status === 'upcoming' && (
                  <span className="text-xs text-accent-600 font-semibold bg-accent-100 px-2 py-0.5 rounded-full">
                    即将开始
                  </span>
                )}
              </div>

              <div className="flex items-center justify-between mb-3">
                <div className="flex flex-col items-center gap-1 flex-1">
                  <span className="text-sm font-semibold text-foreground-900 text-center leading-tight">{match.homeTeam}</span>
                </div>
                <div className="px-3">
                  {match.status === 'upcoming' ? (
                    <span className="text-lg font-heading font-bold text-foreground-400">VS</span>
                  ) : (
                    <span className="text-xl font-heading font-bold text-primary-500">{match.homeScore} - {match.awayScore}</span>
                  )}
                </div>
                <div className="flex flex-col items-center gap-1 flex-1">
                  <span className="text-sm font-semibold text-foreground-900 text-center leading-tight">{match.awayTeam}</span>
                </div>
              </div>

              {match.status === 'live' && (
                <div className="text-center">
                  <span className="text-xs text-primary-500 font-medium">{match.minute}&apos;</span>
                </div>
              )}
            </div>
          ))}
        </div>

        <Link
          to="/category/football"
          className="sm:hidden flex items-center justify-center gap-1 mt-6 text-sm text-primary-500 hover:text-primary-600 font-medium whitespace-nowrap transition-colors duration-200"
        >
          查看全部赛事 <i className="ri-arrow-right-line"></i>
        </Link>
      </div>
    </section>
  );
}